"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisitedOffersProvider = exports.FRAME_ORIGIN = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _VisitedOffersFrame = require("../VisitedOffersFrame");
var _types = require("./types");
var _reactUtils = require("@cian/react-utils");
var _transformToMap = require("./utils/transformToMap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FRAME_ORIGIN = exports.FRAME_ORIGIN = 'https://static.cdn-cian.ru';
const VisitedOffersProvider = _ref => {
  let {
    children,
    settings,
    enabled = true
  } = _ref;
  const [visitedOffers, setVisitedOffers] = React.useState(new Map());
  const [isLoaded, setIsLoaded] = React.useState(false);
  const frameRef = React.useRef(null);
  const postMessageToFrame = React.useCallback(data => {
    const frameContentWindow = frameRef.current && frameRef.current.contentWindow;
    if (frameContentWindow) {
      frameContentWindow.postMessage(data, FRAME_ORIGIN);
    }
  }, [frameRef]);
  const setOfferVisited = React.useCallback(offerId => {
    postMessageToFrame({
      type: _types.EVisitedOffersEventType.SetOfferVisited,
      payload: offerId
    });
  }, [postMessageToFrame]);
  React.useEffect(() => {
    if (!enabled) {
      return () => {};
    }
    const handleVisitedOffersFrameEvents = event => {
      if (event.origin !== FRAME_ORIGIN) {
        return;
      }
      const {
        type,
        payload
      } = event.data;
      if (type === _types.EVisitedOffersEventType.GetVisitedOffers) {
        setVisitedOffers((0, _transformToMap.transformToMap)(payload));
        setIsLoaded(true);
      }
      if (type === _types.EVisitedOffersEventType.SetOfferVisited) {
        setVisitedOffers((0, _transformToMap.transformToMap)(payload));
      }
    };
    window.addEventListener('message', handleVisitedOffersFrameEvents);
    return () => {
      window.removeEventListener('message', handleVisitedOffersFrameEvents);
    };
  }, [enabled]);
  const handleFrameLoad = React.useCallback(() => {
    if (settings) {
      postMessageToFrame({
        type: _types.EVisitedOffersEventType.SetStorageSettings,
        payload: settings
      });
    }
    postMessageToFrame({
      type: _types.EVisitedOffersEventType.GetVisitedOffers
    });
  }, [settings, postMessageToFrame]);
  const isOfferVisited = React.useCallback(offerId => visitedOffers.has(offerId), [visitedOffers]);
  const context = React.useMemo(() => ({
    setOfferVisited,
    isOfferVisited,
    isLoaded
  }), [setOfferVisited, isOfferVisited, isLoaded]);
  return /*#__PURE__*/React.createElement(_context.VisitedOffersContext.Provider, {
    value: context
  }, children, enabled && /*#__PURE__*/React.createElement(_reactUtils.NoSsr, null, /*#__PURE__*/React.createElement(_VisitedOffersFrame.VisitedOffersFrame, {
    ref: frameRef,
    onLoad: handleFrameLoad
  })));
};
exports.VisitedOffersProvider = VisitedOffersProvider;